var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cdl__logo-c"},[_c('Logo',{staticClass:"cdl__logo"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }